var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepage"}},[_c('heading'),_vm._v(" "),_c('main',{class:_vm.activeSectionClass},[_c('cinemas'),_vm._v(" "),_c('program'),_vm._v(" "),_c('detail')],1),_vm._v(" "),_c('LightboxTrailer'),_vm._v(" "),_c('LightboxAbout'),_vm._v(" "),_c('LightboxMobile'),_vm._v(" "),_c('LightboxAdblock')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80ac7d70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Homepage.vue
// module id = OwbB
// module chunks = 1